module.exports = __webpack_public_path__ + "assets/img/TASK_PLUGIN.b4649c6b.svg";